module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Salty Wives, Spirited Mothers, and Savvy Widows")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "css/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "css/page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "content",
    attrs: {
      "id": "contents"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('i', [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('div', [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "id": "pre_1"
    }
  })]), _c('p', {
    staticClass: "con1i"
  }, [_c('a', {
    attrs: {
      "href": "#/Preface#pre"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PREFACE")])])]), _vm._v(" "), _c('div', {
    staticClass: "conte"
  }, [_c('a', {
    attrs: {
      "id": "ch-01"
    }
  }), _c('p', {
    staticClass: "con1"
  }, [_c('a', {
    attrs: {
      "id": "ch-01"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Chapter001#ch01"
    }
  }, [_vm._v("1. Toward Bluer Skies: Reducing the Threat Level and Resurrecting Feminist Studies of Women in Luke")])])]), _vm._v(" "), _c('div', {
    staticClass: "conte"
  }, [_c('a', {
    attrs: {
      "id": "ch-02"
    }
  }), _c('p', {
    staticClass: "con1"
  }, [_c('a', {
    attrs: {
      "id": "ch-02"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Chapter002#ch02"
    }
  }, [_vm._v("2. Can We Go On Together with Suspicious Minds? Doubt and Trust as Both Sides of the Hermeneutical “Coin” (Luke 15:8-10)")])])]), _vm._v(" "), _c('div', {
    staticClass: "conte"
  }, [_c('a', {
    attrs: {
      "id": "ch-03"
    }
  }), _c('p', {
    staticClass: "con1"
  }, [_c('a', {
    attrs: {
      "id": "ch-03"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Chapter003#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. A Woman’s Right to Choose? Mother Mary as Spirited Agent and Actor (Luke 1–2)")])])]), _vm._v(" "), _c('div', {
    staticClass: "conte"
  }, [_c('a', {
    attrs: {
      "id": "ch-04"
    }
  }), _c('p', {
    staticClass: "con1"
  }, [_c('a', {
    attrs: {
      "id": "ch-04"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Chapter004#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The Quest for the Historical Joanna: Follower of Jesus, Friend of Mary Magdalene, and Wife of Herod’s Official (Luke 8:1-3; 24:10)")])])]), _vm._v(" "), _c('div', {
    staticClass: "conte"
  }, [_c('a', {
    attrs: {
      "id": "ch-05"
    }
  }), _c('p', {
    staticClass: "con1"
  }, [_c('a', {
    attrs: {
      "id": "ch-05"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Chapter005#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. A Testy Hostess and Her Lazy Sister? Martha, Mary, and the Household Rivals Type-Scene (Luke 10:38-42)")])])]), _vm._v(" "), _c('div', {
    staticClass: "conte"
  }, [_c('a', {
    attrs: {
      "id": "ch-06"
    }
  }), _c('p', {
    staticClass: "con1"
  }, [_c('a', {
    attrs: {
      "id": "ch-06"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Chapter006#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. A Hungry Widow, Spicy Queen, and Salty Wife: “Foreign” Biblical Models of Warning and Judgment (Luke 4:25-26; 11:31; 17:32)")])])]), _vm._v(" "), _c('div', {
    staticClass: "conte"
  }, [_c('a', {
    attrs: {
      "id": "ch-07"
    }
  }), _c('p', {
    staticClass: "con1"
  }, [_c('a', {
    attrs: {
      "id": "ch-07"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Chapter007#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Savvy Widow’s Might: Fighting for Justice in an Unjust World (Luke 18:1-8)")])])]), _vm._v(" "), _c('div', {
    staticClass: "conte"
  }, [_c('a', {
    attrs: {
      "id": "ch-08"
    }
  }), _c('p', {
    staticClass: "con1"
  }, [_c('a', {
    attrs: {
      "id": "ch-08"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Chapter008#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. A Capable Woman, Who Can Find? We Have Found Some in Luke!")])])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "id": "index_1"
    }
  })]), _c('p', {
    staticClass: "con1i"
  }, [_c('span', {
    attrs: {
      "href": "#/Index#index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INDEX")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b439491","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 69
// module chunks = 0